module.exports = __webpack_public_path__ + "static/kids-slide-eac2f241a1617b6844674caae563746e.jpg";